import { render, staticRenderFns } from "./cHome.vue?vue&type=template&id=8a51660e&"
import script from "./cHome.vue?vue&type=script&lang=js&"
export * from "./cHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports